import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-disclaimer-preview',
  templateUrl: './disclaimer-preview.component.html',
  styleUrls: ['./disclaimer-preview.component.scss'],
})
export class DisclaimerPreviewComponent {
  @Input() list: Array<any>;
  @Input() public activeId: string;

  @Output() editedItem = new EventEmitter<any>();
  @Output() updatedPositionItem = new EventEmitter<any>();
  private subscriptions: Array<Subscription> = [];

  constructor(public changeDetector: ChangeDetectorRef) {}

  ngOnDestroy(): void {
    this.subscriptions.forEach(o => o.unsubscribe());
  }

  public editItem(item) {
    this.activeId = item.id;
    this.editedItem.emit(item);
  }

  public moveItem(position, action, id) {
    this.updatedPositionItem.emit({ currentPosition: position, action: action, id: id });
  }

  public moveItemFromChild($event_move) {
    this.updatedPositionItem.emit($event_move);
  }
}
